<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">                  
        <tabulator
            :columns="columns"
            :showHeader="showTableHeader"
            :pagination="paginateTable"
            ajax-path="connectwise/tickets"
            @rowSelected="showDetails"
        />
        <app-modal
            :show.sync="showDetailsModal"
            width="lg:w-1/2"
        >
            <template slot="header">Ticket Information</template>
            <template slot="body">
                <vue-tabs>
                    <v-tab title="Basic">
                        <div class="mt-5" style="display: grid;grid-gap: 1rem;grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));">
                            <div>
                                <div class="mb-2 font-bold">Ticket #</div>
                                <div>{{ ticket.id }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Priority</div>
                                <div>{{ ticket.priority.name }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Status</div>
                                <div>{{ ticket.status.name }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Summary Description</div>
                                <div>{{ ticket.summary }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Company</div>
                                <div>{{ ticket.company.name }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Resources</div>
                                <div>{{ ticket.resources || '--' }}</div>
                            </div>                 
                        </div>
                    </v-tab>
                    <v-tab title="Company">
                        <div class="mt-5" style="display: grid;grid-gap: 1rem;grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));">
                            <div>
                                <div class="mb-2 font-bold">Name</div>
                                <div>{{ ticket.company.name }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Site</div>
                                <div>{{ ticket.company.siteName }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Address</div>
                                <div>{{ ticket.company.addressLine1 }} {{ ticket.company.city }}, {{ ticket.company.state }} {{ ticket.company.zip }} {{ ticket.company.country ? ticket.company.country.name : '' }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Phone</div>
                                <div>{{ ticket.company.phoneNumber || '--' }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Fax</div>
                                <div>{{ ticket.company.faxNumber || '--' }}</div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Website</div>
                                <div>
                                    <a 
                                        v-if="ticket.company.website"
                                        :href="ticket.company.website"
                                        target="_blank" 
                                    >{{ ticket.company.website }}</a>
                                    <span v-else>--</span>
                                </div>
                            </div>
                            <div>
                                <div class="mb-2 font-bold">Market</div>
                                <div>{{ ticket.company.market ? ticket.company.market.name : '--' }}</div>
                            </div>
                        </div>
                    </v-tab>
                    <v-tab title="Notes">
                        <div class="mt-5">
                            <div 
                                v-for="note in ticket.notes"
                                class="p-4 border border-gray-400 rounded mb-4"
                            >
                                <div><b>{{ note.createdBy }}</b></div>
                                <div class="text-sm text-gray-600">{{ new Date(note.dateCreated).toUTCString() }}</div>
                                <div class="mt-5 whitespace-pre-wrap" v-html="note.text"></div>
                            </div>
                        </div>
                    </v-tab>
                </vue-tabs>                                
            </template>
        </app-modal>
    </div>    
</template>
<script>
    import {VueTabs, VTab} from 'vue-nav-tabs/dist/vue-tabs.js';
    import '@/css/vue-tabs.css'

    export default {
        props: {
            showTableHeader: {
                type: Boolean,
                default: true,
            },
            paginateTable: {
                type: Boolean,
                default: true,
            }
        },
        components: {
            VueTabs,
            VTab,
        },
        data() {
            return {
                showDetailsModal: false,
                ticket: {
                    priority: {},
                    status: {},
                    company: {
                        market: {},
                        country: {},
                    },
                    notes: [],
                },
                columns: [
                    {
                        title: 'Ticket #', 
                        field: 'id', 
                        sorter: 'string',
                        minWidth: 150,
                    },                    
                    {
                        title: 'Priority', 
                        field: 'priority.name', 
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Status', 
                        field: 'status.name', 
                        sorter: 'string',
                        minWidth: 150,  
                    },
                    {
                        title: 'Company', 
                        field: 'company.name',
                        minWidth: 250,
                    },
                    {
                        title: 'Summary Description', 
                        field: 'summary', 
                        sorter: 'string',
                        minWidth: 400,  
                    },
                    {
                        title: 'Resources', 
                        field: 'resources', 
                        sorter: 'string',
                        minWidth: 150,
                        formatter({_cell}) {
                            return _cell.value || '--';
                        }  
                    },
                ],
            }
        },
        methods: {
            showDetails(row) {
                this.ticket = row.data;
                this.showDetailsModal = true;
            },
        }
    }
</script>